export const isEmailValid = (email) => {
  return new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(email);
};

export const isPasswordValid = (password) => {
  return !!password && password != "" && password.length >= 4;
};
